import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import useSWR from 'swr';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { dataFetcher, endpoints, baseUrl, cloudBaseUrl, axios as apiAxios } from 'Api';
import axios from 'axios';
import { Skeleton } from '@mui/material';
import { AppContext, AuthContext } from 'Context';
import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from 'Components';
import CustomButton from 'Components/button/CustomButton';
import { get } from 'lodash';
import { saveUploadInfo, saveUploadDetails, saveDummy, removeDummy } from 'store/store';
import { uploadLargeFile } from 'Utils/uploadWrapper';
import uploadManager from 'Utils/uploadManagerSecure';
import { ALLOWED_UPLOADS_COUNT } from 'Commons';
import MobileUploadQRModal from 'Components/UploadDropdown/MobileUploadQRModal';
import CloudUploadModal from 'Components/UploadDropdown/CloudUploadModal';
import ForNoImage from 'Assets/Placeholder.png';
import {
  awsConfig,
  generateS3Url,
  getBucketName,
  getBucketNamePath,
} from '../../../../Api/awsConfig';
import Logo from '../../../../Assets/published.png';
import { StoragePage } from '../components/page';
import { videoArray } from './DataArray';
import { photoArray } from './PhotoArray';
import Publish from '../PublishUi/Publish';
import Sort from '../../../../Assets/sort.png';
import Shimmer from '../Shimmer';
import styles from './index.module.css';

const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.avi', '.mkv', '.wmv', '.flv', '.webm', '.m4v', '.3gp', '.mpg', '.mpeg', '.ts', '.mts'];
const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.heic', '.heif', '.tiff', '.tif', '.svg'];
const FILE_ACCEPT = `${[...VIDEO_EXTENSIONS, ...IMAGE_EXTENSIONS].join(',')},video/*,image/*`;

function changeSize(size) {
  const newSize = size / 1024 / 1024;
  return newSize.toFixed(2);
}

export const Storage = () => {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState({ results: [], next: null });
  const [loading, setLoading] = useState(false);
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [page, setPage] = useState(1);
  const containerRef = useRef(null);
  const {
    storageSearchTerm,
    storageSelectedDate,
    storageTabTitle,
    storageSelectedItems,
    setStorageSelectedItems,
    setOpenX,
    cloudToken,
    setAppSnackbar,
    userDetails,
    setUploadContainer,
    setUploadContainer2,
    setIamUploading,
    setDraftCategoryState,
    base64ToBinary,
    // Global upload panel's download-progress state (same as the top upload dropdown)
    setDownloadBox,
    setDownloadingFiles,
    // Free-plan limit check + upgrade ("buy") popup (same as the top upload dropdown)
    IsfreePlan,
    setTrailPopUpModalVisible,
    autoSignIn,
  } = useContext(AppContext);
  const { getToken } = useContext(AuthContext);
  const userId = userDetails?.isSubscription?.user_id || localStorage.getItem('id');

  // Redux upload tracking — drives the app's global upload widget
  const dispatch = useDispatch();
  const uploadPercentages = useSelector((state) => state.upload);
  const updateUploadPercentages = (draftId, data) => {
    dispatch(saveUploadInfo({ [draftId]: data }));
  };
  const updateUploadDetails = (draftId, data) => {
    dispatch(saveUploadDetails({ [draftId]: data }));
  };
  const updateDummy = (dummy, status = 0) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const [thumbnailSelected, setThumbnailSelected] = useState();
  const [sendDataLoader, setSendDataLoader] = useState(false);
  const [addToProjector, setAddToProjector] = useState(false);
  const [order, setOrder] = useState('ascending');
  const [detailsData, setDetailsData] = useState({
    title: '',
    duration: undefined,
    height: undefined,
    width: undefined,
    description: '',
    categrory: undefined,
    visibility: 2,
    group: [], // ✅ Must be an array!
  });
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / 1024 ** i).toFixed(2)} ${sizes[i]}`;
  };
  const groupByDate = (files) => {
    if (!Array.isArray(files)) return {};
    return files.reduce((acc, file) => {
      const dateObj = new Date(file.uploaded_at);
      const formattedDate = dateObj.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(file);
      return acc;
    }, {});
  };
  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const groupedFiles = groupByDate(data?.results);
  const handleSelect = (item) => {
    const isAlreadySelected = storageSelectedItems.some(
      (selected) => selected.id === item.id
    ); // assuming `id` is unique
    if (isAlreadySelected) {
      setStorageSelectedItems(
        storageSelectedItems.filter((selected) => selected.id !== item.id)
      );
    } else {
      setStorageSelectedItems([...storageSelectedItems, item]);
    }
  };
  const fetchData = async (pageNumber = 1) => {
    if (pageNumber === 1) setLoading(true);
    setLoadingNextPage(pageNumber > 1);
    const token = cloudToken?.access;
    const isLocalhost = window.location.hostname !== 'localhost';
    try {
      const baseUrl = `${cloudBaseUrl}/documents/list/?type=video&order=${order}&limit=50&search=${storageSearchTerm}&date=${storageSelectedDate}`;
      const params = new URLSearchParams({
        type: storageTabTitle === 0 ? 'video' : 'photo',
        order: 'descending',
        page: String(pageNumber),
      });
      if (storageSearchTerm) {
        params.append('search', storageSearchTerm);
      }
      if (storageSelectedDate) {
        params.append('date', storageSelectedDate);
      }
      // const url = `${baseUrl}?${params.toString()}`;
      const url = baseUrl;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      // Parse the response body
      const responseData = await response.json();
      console.log('Response Data:', responseData);
      // setData((prev) => ({
      //   ...responseData,
      //   results: [...(prev?.results ?? []), ...(responseData?.results ?? [])],
      // }));
      setData((prev) => ({
  ...responseData,
  results:
    pageNumber === 1
      ? responseData?.results ?? []
      : [...(prev?.results ?? []), ...(responseData?.results ?? [])],
}));

      setPage(pageNumber);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoadingNextPage(false);
    }
  };
  useEffect(() => {
    if (cloudToken?.access) {
      fetchData(1);
    }
  }, [
    storageSearchTerm,
    storageSelectedDate,
    storageTabTitle,
    cloudToken,
    order,
  ]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (
        !loading
        && data.next
        && !loadingNextPage
        && scrollTop + clientHeight + 100 >= scrollHeight
      ) {
        const nextPage = page + 1;
        fetchData(nextPage);
      }
    };
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [loading, data.next, page, loadingNextPage]);
  async function urlToFile(url, filename) {
    const response = await fetch(url);
    const blob = await response.blob();
    const fileType = blob.type || 'image/jpeg'; // fallback
    return new File([blob], filename, { type: fileType });
  }
  async function appendThumbnails(formData, storageSelectedItems) {
    const preThumbnails = storageSelectedItems?.[0]?.pre_thumbnails;
    if (!Array.isArray(preThumbnails) || preThumbnails.length === 0) {
      console.warn('No thumbnails found.');
      return;
    }
    // eslint-disable-next-line
    for (let index = 0; index < preThumbnails.length; index++) {
      const url = preThumbnails[index];
      try {
        // eslint-disable-next-line
        const file = await urlToFile(url, `thumbnail_${index}.jpg`);
        console.log('thumbnails[]', file);
        formData.append('thumbnails[]', file);
      } catch (err) {
        console.error(`Error processing thumbnail ${index}:`, err);
      }
    }
  }

  const convertAllUrlsToFiles = async (urls) => {
    const files = await Promise.all(
      urls.map((url, index) => urlToFile(url, `thumbnail_${index}.png`))
    );

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('thumbnails[]', file);
    });

    return formData;
  };
  useEffect(() => {
    // Clear selected items when route changes
    setStorageSelectedItems([]);
  }, [location.pathname]); // triggered every time the path changes

  const addVideo = async () => {
    const selected = storageSelectedItems[0];
    let thumbnailsArray = [];
    try {
      thumbnailsArray = JSON.parse(selected?.thumbnails || '[]');
    } catch (err) {
      console.error('Invalid thumbnails JSON:', err);
    }
    const cleanUrl = selected?.pre_thumbnail?.split('?')[0] ?? '';
    const matchedThumb = thumbnailsArray.find((thumb) => cleanUrl.includes(thumb));
    const url = `${baseUrl}/cloud/addVideo`;
    const payload = {
      title: detailsData?.title,
      description: detailsData?.description,
      file_key: storageSelectedItems[0]?.url,
      thumbnail_key: matchedThumb,
      thumbnails_keys: JSON.parse(storageSelectedItems[0]?.thumbnails || '[]'),
      category: detailsData?.categrory,
      visibility: detailsData?.visibility,
      group: detailsData?.group,
      video_size: storageSelectedItems[0]?.size,
      video_duration: 50,
      token: getToken(),
    };

    try {
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Upload Success:', response.data);
      setStorageSelectedItems([]);
      fetchData(1);
      setAddToProjector(false);
      setSendDataLoader(false);
      return response.data;
    } catch (error) {
      console.error('Upload Failed:', error?.response?.data || error.message);
      return null;
    }
  };
  const [deleteLoading, setDeleteLoading] = useState(false);
  const deleteFiles = async () => {
    setDeleteLoading(true);
  const payload = {
  ids: storageSelectedItems?.map((item) => item?.id), // e.g. [1473, 1466, 1460]
  stream_ids: [],
  streamToken: getToken(),
    };
    console.log('Payload before request:', payload);
  try {
    const response = await axios.post(
      `${cloudBaseUrl}/documents/delete-files/`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cloudToken?.access}`,
        }
      }
    );
      setStorageSelectedItems([]);
    setDeleteLoading(false);
    setTimeout(() => {
      fetchData(1);
    }, 1000);
    console.log('Delete Success:', response.data);
  } catch (error) {
 setDeleteLoading(false);
    console.error('Delete Failed:', error.response?.data || error.message);
  }
};

  const beforeDataSendToServer = (videoUrl) => {
    setSendDataLoader(true);
    addVideo();
  };

  const publishHandler = () => {
    if (addToProjector) {
      beforeDataSendToServer(storageSelectedItems[0].pre_url);
      return;
    }
    if (storageSelectedItems?.length === 1) {
      setAddToProjector(true);
    } else {
      setOpenX(true);
    }
  };

  // ── Uploader grid (ported from /gift flow + QuickUserUpload pipeline) ──
  const filesInputRef = useRef(null);
  const photoAlbumIdRef = useRef(null);
  const [showMobileQr, setShowMobileQr] = useState(false);
  const [cloudModalOpen, setCloudModalOpen] = useState(false);
  const [selectedCloudService, setSelectedCloudService] = useState(null);

  const openCloudModal = (service) => {
    setSelectedCloudService(service);
    setCloudModalOpen(true);
  };
  const handleCloudModalClose = () => {
    setCloudModalOpen(false);
    setSelectedCloudService(null);
  };

  // Free-plan limit check — same as the top upload dropdown. Returns true (and
  // shows the upgrade "buy" popup) when a free user is at the item cap, so the
  // caller can bail out before starting the upload. Returns false otherwise.
  const isUploadLimitBlocked = async () => {
    try {
      const res = await autoSignIn();
      const currentlyUploadingCount = uploadManager.getCurrentlyUploadingCount();
      if (
        IsfreePlan
        && !res?.data?.subscription
        && res?.data?.totalContentUploaded + currentlyUploadingCount >= ALLOWED_UPLOADS_COUNT
      ) {
        setTrailPopUpModalVisible(true);
        return true;
      }
    } catch (error) {
      // Don't block the user if the check fails.
      console.error('[StorageUpload] Error checking upload limits:', error);
    }
    return false;
  };

  // Wrap a grid-option action so it runs the free-plan limit check first.
  const withLimitCheck = (action) => async () => {
    if (await isUploadLimitBlocked()) return;
    action();
  };

  // Record Yourself — sends the user to /gift-content with
  // autoRecord=true&fromNormalApp=true, which auto-pops the "Tell Your Story"
  // recorder overlay. Recorded clips upload through gift-content's direct
  // addVideo pipeline (handles MediaRecorder webm correctly), and fromNormalApp
  // returns the user to /your-videos once they finish.
  const handleRecordYourself = async () => {
    if (await isUploadLimitBlocked()) return;
    const base = Pathname.giftFlow.content;
    const sep = base.includes('?') ? '&' : '?';
    navigate(`${base}${sep}autoRecord=true&fromNormalApp=true`);
  };

  // Convert the placeholder image to base64 (used when no thumbnail can be made)
  const getForNoImageBase64 = async () => {
    const response = await fetch(ForNoImage);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  // Backend fallback for thumbnail generation (sends first 5MB of video)
  const callBackendThumbnailAPI = async (file) => {
    try {
      const videoFilePiece = new FormData();
      videoFilePiece.append('video_file', file.slice(0, 5 * 1024 * 1024));
      const response = await fetch('https://conf.eq7.in/generate-thumbnail/', {
        method: 'POST',
        body: videoFilePiece,
      });
      if (!response.ok) throw new Error(`Server error ${response.status}`);
      const data = await response.json();
      if (data?.thumbnail) {
        const res = await fetch(`data:image/png;base64,${data.thumbnail}`);
        const blob = await res.blob();
        return [blob];
      }
      return [];
    } catch (err) {
      console.error('[StorageUpload] Backend thumbnail generation failed:', err);
      return [];
    }
  };

  // Generate thumbnails from a video file using canvas, with backend fallback
  const generateThumbnailsFromVideo = (file) => new Promise((resolve) => {
    const video = document.createElement('video');
    const videoUrl = URL.createObjectURL(file);
    video.src = videoUrl;
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.playsInline = true;

    const fallbackToBackend = async () => {
      URL.revokeObjectURL(videoUrl);
      video.remove();
      const backendBlobs = await callBackendThumbnailAPI(file);
      resolve({ thumbnailBlobs: backendBlobs, videoHeight: 0, videoWidth: 0 });
    };

    video.onerror = () => { fallbackToBackend(); };

    video.onloadeddata = () => {
      const { duration } = video;
      const vHeight = video.videoHeight;
      const vWidth = video.videoWidth;
      const thumbnailCount = 6;
      const interval = duration / (thumbnailCount + 1);
      const tempBlobs = [];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      let currentIndex = 1;

      const captureNextFrame = () => {
        if (currentIndex > thumbnailCount) {
          URL.revokeObjectURL(videoUrl);
          video.remove();
          if (tempBlobs.length === 0) {
            callBackendThumbnailAPI(file).then((backendBlobs) => {
              resolve({ thumbnailBlobs: backendBlobs, videoHeight: vHeight, videoWidth: vWidth });
            });
            return;
          }
          resolve({ thumbnailBlobs: tempBlobs, videoHeight: vHeight, videoWidth: vWidth });
          return;
        }
        video.currentTime = interval * currentIndex;
        video.onseeked = () => {
          canvas.width = vWidth;
          canvas.height = vHeight;
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          canvas.toBlob((blob) => {
            if (blob) tempBlobs.push(blob);
            currentIndex += 1;
            captureNextFrame();
          }, 'image/jpeg', 0.9);
        };
      };
      captureNextFrame();
    };
  });

  const blobToBase64 = (blob) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });

  // Save video metadata after the S3 upload completes (secure-upload aware)
  const addVideoToAPI = async (draftID, draftState, secureUploadData = null) => {
    const formData = new FormData();
    const draftData = draftState[draftID];
    const isSecureUpload = secureUploadData && secureUploadData.s3Key;
    if (draftData) {
      formData.append('draft_id', draftID || '');
      formData.append('title', draftData.title || '');
      formData.append('category_id', draftData.category || '');
      formData.append('file_name', draftData.fileName || '');
      if (isSecureUpload) {
        formData.append('file_key', secureUploadData.s3Key);
        formData.append('document_id', secureUploadData.documentId || '');
        formData.append('bucket_folder_path', secureUploadData.s3Key);
        if (draftData.thumbnail) {
          formData.append('thumbnail', base64ToBinary(draftData.thumbnail));
        }
        if (secureUploadData.thumbnails && Array.isArray(secureUploadData.thumbnails)) {
          secureUploadData.thumbnails.forEach((thumbnail, index) => {
            if (thumbnail && index !== draftData.selectedThumbnailIndex) {
              const binary = typeof thumbnail === 'string' ? base64ToBinary(thumbnail) : thumbnail;
              formData.append('thumbnails[]', binary);
            }
          });
        }
      } else {
        if (draftData.thumbnail) {
          formData.append('thumbnail', base64ToBinary(draftData.thumbnail));
        }
        if (draftData.thumbnails && Array.isArray(draftData.thumbnails)) {
          draftData.thumbnails.forEach((binary, index) => {
            if (binary && index !== draftData.selectedThumbnailIndex) {
              formData.append('thumbnails[]', binary);
            }
          });
        }
        formData.append('uploadKey', draftData.uploadKey || '');
        formData.append('bucket_folder_path', `${draftData.s3Url}${draftData.uploadBucket}/${draftData.uploadKey}`);
        formData.append('s3_image_bucket_url', draftData.s3Url || '');
      }
      formData.append('description', draftData.description || '');
      formData.append('video_size', changeSize(draftData.videoSize) || '');
      formData.append('group_ids', (draftData.selectedGroups || []).join(','));
      formData.append('visibility', draftData.visibility || '');
      formData.append('subcategory_id', draftData.selectedSubCategory || '');
      formData.append('playlist_ids', draftData.selectedPlaylist || '');
      formData.append('videoHeight', draftData.videoHeight || '');
      formData.append('videoWidth', draftData.videoWidth || '');
      formData.append('videoOreintation', draftData.orientation || '');
      formData.append('s3_status', draftData.uploadStatus || '');
    }
    const response = await apiAxios.post(`${baseUrl}/V6/addVideo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  };

  // Upload a single video through the app's upload manager (global progress widget)
  const startVideoUpload = async (videoFile) => {
    const fileExtension = videoFile.name.split('.').pop().toLowerCase();
    const number = Math.floor(Math.random() * 10000) + 1;
    const fileName = `${Date.now()}-${userId}-video-${number}.${fileExtension}`;
    const bucketName = getBucketName(userId);
    const s3Url = generateS3Url();
    const draftID = uuid();
    const videoSize = videoFile.size;

    const { thumbnailBlobs, videoHeight, videoWidth } = await generateThumbnailsFromVideo(videoFile);
    let thumbnailBase64;
    let thumbnailsBinary;
    if (thumbnailBlobs.length > 0) {
      thumbnailBase64 = await blobToBase64(thumbnailBlobs[0]);
      thumbnailsBinary = await Promise.all(
        thumbnailBlobs.map((blob) => blobToBase64(blob).then((b64) => base64ToBinary(b64)))
      );
    } else {
      thumbnailBase64 = await getForNoImageBase64();
      thumbnailsBinary = [base64ToBinary(thumbnailBase64)];
    }

    uploadLargeFile({
      userId,
      bucket: bucketName,
      key: fileName,
      file: videoFile,
      draftId: draftID,
      thumbnails: thumbnailsBinary,
      uploadPercentages,
      updateUploadPercentages,
      setUploadContainer,
      setUploadContainer2,
      setIamUploading,
      dummyData: {
        title: videoFile.name.replace(/\.[^/.]+$/, ''),
        fileName: videoFile.name,
        thumbnail: thumbnailBase64,
        thumbnails: thumbnailsBinary,
        ForNoImage,
        category: 'All Videos',
        description: '',
        videoSize,
        selectedGroups: [],
        changeSize,
      },
      updateDummy,
      setDraftCategoryState,
      onSuccess: async (draftId, secureUploadData = null) => {
        const isSecureUpload = secureUploadData && secureUploadData.s3Key;
        const updatedDraftData = {
          title: videoFile.name.replace(/\.[^/.]+$/, ''),
          category: '',
          fileName: videoFile.name,
          thumbnail: thumbnailBase64,
          thumbnails: thumbnailsBinary,
          selectedThumbnailIndex: 0,
          description: '',
          videoSize,
          selectedGroups: [],
          visibility: '2',
          selectedSubCategory: '',
          selectedPlaylist: '',
          videoHeight,
          videoWidth,
          orientation: videoHeight < videoWidth ? 1 : 2,
          uploadStatus: 'completed',
          uploadKey: isSecureUpload ? secureUploadData.s3Key : fileName,
          uploadBucket: isSecureUpload ? '' : bucketName,
          s3Url: isSecureUpload ? '' : s3Url,
        };
        setDraftCategoryState((prevState) => ({ ...prevState, [draftId]: updatedDraftData }));
        try {
          await addVideoToAPI(draftId, { [draftId]: updatedDraftData }, secureUploadData);
        } catch (error) {
          console.error('[StorageUpload] Failed to add video to API:', error);
        }
      },
      onError: (error, draftId) => {
        console.error('[StorageUpload] Upload failed for draft:', draftId, error);
      },
      updateUploadDetails,
    });
  };

  // Upload photos as a "All Photos" album through the app's pipeline
  const startPhotoAlbumUpload = async (imageFiles) => {
    let albumId = photoAlbumIdRef.current;
    if (!albumId) {
      try {
        const albumListResponse = await apiAxios.post(`${baseUrl}/getAlbumList`, {});
        const existingAlbums = albumListResponse.data?.data || [];
        const allPhotosAlbum = existingAlbums.find((a) => a.title === 'All Photos');
        if (allPhotosAlbum) albumId = allPhotosAlbum.album_id || allPhotosAlbum.id;
      } catch (err) {
        console.warn('[StorageUpload] Failed to fetch album list, will create new album:', err);
      }
      if (!albumId) {
        const response = await apiAxios.post(`${baseUrl}/addEditAlbum`, {
          title: 'All Photos',
          description: '',
          visibility: '2',
          group_id: '',
          token: getToken(),
        });
        albumId = response.data?.album_id;
        if (!albumId) {
          console.error('[StorageUpload] Failed to create album');
          return;
        }
      }
      photoAlbumIdRef.current = albumId;
    }

    const totalPhotos = imageFiles.length;
    const iconBase64 = await blobToBase64(imageFiles[0]);

    uploadManager.createPhotoUpload({
      albumId,
      albumTitle: 'Photo Album',
      photoCount: totalPhotos,
      updateUploadPercentages,
    });
    updateUploadPercentages(albumId, `0/${totalPhotos}`);

    let successfulUploadCount = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (let i = 0; i < imageFiles.length; i += 1) {
      try {
        const formData = new FormData();
        formData.append('album_id', albumId);
        formData.append('visibility', '2');
        formData.append('group_id', '');
        if (i === 0 && iconBase64) formData.append('icon', iconBase64);
        formData.append('token', getToken());
        formData.append('photo_file[]', imageFiles[i], imageFiles[i].name);
        // eslint-disable-next-line no-await-in-loop
        await apiAxios.post(`${baseUrl}/addPhotoContent`, formData);
        successfulUploadCount += 1;
        updateUploadPercentages(albumId, `${successfulUploadCount}/${totalPhotos}`);
        uploadManager.updatePhotoUploadProgress(albumId, successfulUploadCount, totalPhotos);
      } catch (error) {
        console.error(`[StorageUpload] Error uploading photo ${i + 1}:`, error);
      }
    }

    updateUploadPercentages(albumId, null);
    uploadManager.completePhotoUpload(albumId);
    setAppSnackbar({
      isVisible: true,
      type: 'success',
      message: `Uploaded ${successfulUploadCount} ${successfulUploadCount === 1 ? 'photo' : 'photos'}`,
    });
  };

  // Single "Choose Files" picker → auto-split videos vs photos → real pipeline
  const handleFileSelect = async (event) => {
    const files = Array.from(event.target.files || []);
    const inputElement = event.target;
    inputElement.value = ''; // allow re-selecting the same files
    if (files.length === 0) return;

    const videoFiles = [];
    const imageFiles = [];
    files.forEach((file) => {
      const ext = `.${file.name.split('.').pop().toLowerCase()}`;
      if (VIDEO_EXTENSIONS.includes(ext)) videoFiles.push(file);
      else if (IMAGE_EXTENSIONS.includes(ext)) imageFiles.push(file);
    });

    if (videoFiles.length === 0 && imageFiles.length === 0) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Unsupported file type. Please choose videos or photos.',
      });
      return;
    }

    videoFiles.forEach((videoFile) => { startVideoUpload(videoFile); });
    if (imageFiles.length > 0) startPhotoAlbumUpload(imageFiles);
  };

  // Resolve a direct download URL (+ headers) for a cloud file.
  const getCloudDownloadUrl = async (file, service, cloudAccessToken) => {
    if (service === 'dropbox') {
      const dropboxHeaders = {
        Authorization: `Bearer ${cloudAccessToken}`,
        'Content-Type': 'application/json',
      };
      if (file.namespaceId) {
        dropboxHeaders['Dropbox-API-Path-Root'] = JSON.stringify({
          '.tag': 'namespace_id',
          namespace_id: file.namespaceId,
        });
      }
      const response = await axios.post(
        'https://api.dropboxapi.com/2/files/get_temporary_link',
        { path: file.id },
        { headers: dropboxHeaders },
      );
      return { tempUrl: response.data.link, headers: {} };
    }
    // googledrive
    return {
      tempUrl: `https://www.googleapis.com/drive/v3/files/${file.id}?alt=media`,
      headers: { Authorization: `Bearer ${cloudAccessToken}` },
    };
  };

  // Download a cloud file with a live entry in the global upload panel's download
  // section (drives downloadingFiles — same state the top upload dropdown uses), so
  // it shows "Downloading N%" with speed/ETA before the upload phase begins.
  const downloadCloudFileWithProgress = async (file, service, cloudAccessToken) => {
    setDownloadingFiles((prev) => prev.map((f) => (f.id === file.id
      ? { ...f, status: 'downloading', progress: 0 } : f)));

    const { tempUrl, headers } = await getCloudDownloadUrl(file, service, cloudAccessToken);
    const downloadResponse = await fetch(tempUrl, { headers });
    if (!downloadResponse.ok) throw new Error(`Failed to download ${file.name}`);

    const contentLength = downloadResponse.headers.get('content-length');
    const totalBytes = contentLength ? parseInt(contentLength, 10) : (file.size || 0);
    const reader = downloadResponse.body.getReader();
    const chunks = [];
    let receivedBytes = 0;
    let lastUpdate = 0;
    let lastSpeedTime = 0;
    let lastSpeedBytes = 0;
    let speed = 0;

    // eslint-disable-next-line no-constant-condition
    while (true) {
      // eslint-disable-next-line no-await-in-loop
      const { done, value } = await reader.read();
      if (done) break;
      chunks.push(value);
      receivedBytes += value.length;
      const now = Date.now();
      if (now - lastUpdate > 100) {
        lastUpdate = now;
        if (now - lastSpeedTime > 500) {
          const dt = (now - lastSpeedTime) / 1000;
          if (lastSpeedTime > 0 && dt > 0) speed = (receivedBytes - lastSpeedBytes) / dt;
          lastSpeedTime = now;
          lastSpeedBytes = receivedBytes;
        }
        const receivedSnapshot = receivedBytes;
        const speedSnapshot = speed;
        const progress = totalBytes > 0 ? Math.round((receivedSnapshot / totalBytes) * 100) : 0;
        const eta = speedSnapshot > 0 && totalBytes > 0
          ? Math.round((totalBytes - receivedSnapshot) / speedSnapshot) : 0;
        // eslint-disable-next-line no-loop-func
        setDownloadingFiles((prev) => prev.map((f) => (f.id === file.id
          ? {
            ...f, progress, receivedBytes: receivedSnapshot, speed: speedSnapshot, eta,
          } : f)));
      }
    }

    const blob = new Blob(chunks);
    setDownloadingFiles((prev) => prev.map((f) => (f.id === file.id
      ? { ...f, progress: 100, status: 'completed' } : f)));
    return new File([blob], file.name, {
      type: file.mimeType || blob.type || 'application/octet-stream',
    });
  };

  // Files chosen from the cloud browser → download → existing upload pipeline
  const handleCloudFilesSelected = async (files, service) => {
    if (!files || files.length === 0) return;
    handleCloudModalClose();

    const cloudServices = localStorage.getItem('cloudConnectedServices');
    const cloudAccessToken = cloudServices
      ? JSON.parse(cloudServices)[service]?.accessToken
      : null;
    if (!cloudAccessToken) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Cloud service not connected',
      });
      return;
    }

    const isVideoFile = (f) => f.fileType === 'video'
      || VIDEO_EXTENSIONS.includes(`.${f.name.split('.').pop().toLowerCase()}`);

    // Show the global upload panel's download section with every cloud file queued
    // (first 2 downloading, rest queued) — same as the top upload dropdown.
    const MAX_CONCURRENT_DOWNLOADS = 2;
    setDownloadBox(true);
    setDownloadingFiles(files.map((file, index) => ({
      id: file.id,
      name: file.name,
      progress: 0,
      status: index < MAX_CONCURRENT_DOWNLOADS ? 'downloading' : 'queued',
      source: 'cloud',
    })));

    // Downloaded photos are collected and batch-uploaded to the album once all done.
    const downloadedImages = [];

    // Download all files with a concurrency of 2. Each file shows Downloading N% in the
    // panel; videos then start their S3 upload (fire-and-forget) so the panel flips to
    // Uploading, while the freed slot picks up the next queued download.
    let cursor = 0;
    const runNext = async () => {
      if (cursor >= files.length) return;
      const file = files[cursor];
      cursor += 1;
      try {
        const fileObject = await downloadCloudFileWithProgress(file, service, cloudAccessToken);
        if (isVideoFile(file)) {
          startVideoUpload(fileObject);
        } else {
          downloadedImages.push(fileObject);
        }
      } catch (err) {
        console.error('[StorageUpload] Cloud import failed for:', file?.name, err);
        setDownloadingFiles((prev) => prev.map((f) => (f.id === file.id ? { ...f, status: 'error' } : f)));
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: `Failed to import ${file?.name}`,
        });
      }
      await runNext();
    };

    const workers = [];
    for (let i = 0; i < Math.min(MAX_CONCURRENT_DOWNLOADS, files.length); i += 1) {
      workers.push(runNext());
    }
    await Promise.all(workers);

    if (downloadedImages.length > 0) startPhotoAlbumUpload(downloadedImages);
  };

  return (
//     <StoragePage
//   title={data?.results?.length > 0 ? `${data.results.length} Videos` : 'Add videos'}
// >
//       <div className={styles.viewersDiv}>
//         <div className={styles.aboveGrid}>
//           {data?.results?.length > 0 && (
//           <button
//             onClick={() => setOrder((prev) => (prev === 'ascending' ? 'descending' : 'ascending'))}
//             className={styles.orderSort}
//           >
//             <img src={Sort} className="w-[14px]" alt="" />
//             {order === 'ascending' ? 'Latest' : 'Oldest'}
//           </button>
//           )}
//           {Object.entries(groupedFiles)?.map(([date, files]) => (
//             <div className={styles.topix}>
//               <span className={styles.date}>{date}</span>
//               <div className={styles.allViewersContainer} ref={containerRef}>
//                 {loading ? (
//                   <div className={styles.shimmer}>
//                     <Shimmer type="video" />
//                   </div>
//                 ) : data?.results?.length > 0 ? (
//                   data?.results?.map((item, index) => (
//                     <div
//                       className={styles.gridImg}
//                       key={item?.id}
//                       role="button"
//                       tabIndex={0}
//                       onClick={() => handleSelect(item)}
//                       onKeyDown={(e) => {
//                         if (e.key === 'Enter' || e.key === ' ') {
//                           handleSelect(item);
//                         }
//                       }}
//                     >
//                       <Checkbox
//                         checked={storageSelectedItems?.some(
//                           (selected) => selected.id === item.id
//                         )}
//                         icon={<></>} // ✅ safely renders nothing
//                         checkedIcon={<CheckCircleIcon />} // ✅ shown only when selected
//                         sx={{
//                           color: '#e6dfda',
//                           '&.Mui-checked': {
//                             color: '#e6dfda',
//                           },
//                         }}
//                         style={{
//                           position: 'absolute',
//                           top: '40%',
//                           left: '42%',
//                           zIndex: 2,
//                           borderRadius: 4,
//                           padding: 0,
//                           pointerEvents: 'none', // allow click-through
//                         }}
//                       />

//                       <img
//                         src={item?.pre_thumbnail}
//                         className={styles.eachbyimg}
//                         alt={item?.name}
//                       />
//                       {item?.draft_id !== null && (
//                         <img
//                           className={styles.isStream}
//                           src={Logo}
//                           alt={item?.name}
//                         />
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <div className={styles.noData}>No data found</div>
//                 )}
//                 {loadingNextPage
//                   && Array.from({ length: 16 }).map((_, index) => (
//                     <div
//                       className={styles.gridItemX}
//                       key={index + data.results.length}
//                     >
//                       <Skeleton
//                         variant="rectangular"
//                         height={130}
//                         width={100}
//                         animation="wave"
//                         sx={{
//                           borderRadius: '12px',
//                         }}
//                       />
//                     </div>
//                   ))}
//               </div>
//             </div>
//           ))}
//         </div>
//         {storageSelectedItems?.length > 0 && (
//           <div className={styles.pendingViewersContainer}>
//             <Publish
//               type="video"
//               addToProjector={addToProjector}
//               setSelectedCheckedItems={setStorageSelectedItems}
//               selectedCheckedItems={storageSelectedItems}
//               formatFileSize={formatFileSize}
//               handleDetailsChange={handleDetailsChange}
//               detailsData={detailsData}
//               setDetailsData={setDetailsData}
//               thumbnailSelected={thumbnailSelected}
//               setThumbnailSelected={setThumbnailSelected}
//             />

//             <div className={styles.buttonsfleximo}>
//               <CustomButton onClick={deleteFiles} loading={deleteLoading} border="red" name="Delete" />
//               {storageSelectedItems?.length > 0
//                 && !storageSelectedItems.some(
//                   (item) => item?.draft_id !== null
//                 ) && (
//                   <CustomButton
//                     disabled={
//                       storageSelectedItems?.length < 1 || sendDataLoader
//                     }
//                     onClick={publishHandler}
//                     loading={sendDataLoader}
//                     border="#5AA5EF"
//                     name="Publish Video"
//                   />
//                 )}
//             </div>
//           </div>
//         )}
//       </div>
// </StoragePage>
    <StoragePage>
      <div className={styles.uploadGridWrapper}>
        <h2 className={styles.stepSubHeading}>Upload Your Media</h2>
        <p className={styles.stepSubText}>Add videos and photos to your library</p>

        {/* Hidden file input for local uploads (videos + photos) */}
        <input
          ref={filesInputRef}
          type="file"
          accept={FILE_ACCEPT}
          multiple
          style={{ display: 'none' }}
          onChange={handleFileSelect}
        />

        <div className={styles.uploadOptionsGrid}>
          {/* ── Row 1 ── */}
          <div className={styles.uploadOptionsRow}>
            {/* Choose Local Files */}
            <div
              aria-hidden="true"
              className={`${styles.uploadOptionBox} ${styles.optionSlideIn} ${styles.optionDelay1}`}
              onClick={withLimitCheck(() => filesInputRef.current?.click())}
            >
              <div className={styles.uploadOptionIcon}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="#02071A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14 2V8H20" stroke="#02071A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 18V12" stroke="#02071A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 15L12 12L15 15" stroke="#02071A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <span className={styles.uploadOptionText}>Choose Local Files</span>
            </div>
            {/* Upload From Mobile */}
            <div
              aria-hidden="true"
              className={`${styles.uploadOptionBox} ${styles.optionSlideIn} ${styles.optionDelay2}`}
              onClick={withLimitCheck(() => setShowMobileQr(true))}
            >
              <div className={styles.uploadOptionIcon}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="5" y="1" width="14" height="22" rx="3" stroke="#02071A" strokeWidth="1.5" />
                  <line x1="10" y1="3.5" x2="14" y2="3.5" stroke="#02071A" strokeWidth="1.5" strokeLinecap="round" />
                  <circle cx="12" cy="19" r="1" fill="#02071A" />
                </svg>
              </div>
              <span className={styles.uploadOptionText}>Upload From Mobile</span>
            </div>
            {/* Record Yourself */}
            <div
              role="button"
              tabIndex={0}
              aria-label="Record yourself"
              className={`${styles.uploadOptionBox} ${styles.optionSlideIn} ${styles.optionDelay3}`}
              onClick={handleRecordYourself}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleRecordYourself(); }}
            >
              <div className={styles.uploadOptionIcon}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="6" width="14" height="12" rx="2" stroke="#02071A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M22 8L16 12L22 16V8Z" stroke="#02071A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="9" cy="12" r="2.6" fill="#ff4d4f" />
                </svg>
              </div>
              <span className={styles.uploadOptionText}>Record Yourself</span>
            </div>
          </div>

          {/* ── Row 2 ── */}
          <div className={`${styles.uploadOptionsRow} ${styles.uploadOptionsRowCompact}`}>
            {/* Apple Photos */}
            <div
              aria-hidden="true"
              className={`${styles.uploadOptionBox} ${styles.optionSlideIn} ${styles.optionDelay4}`}
              onClick={withLimitCheck(() => setShowMobileQr(true))}
            >
              <div className={styles.uploadOptionIcon}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.05 20.28c-.98.95-2.05.79-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" fill="#555" />
                </svg>
              </div>
              <span className={styles.uploadOptionText}>Apple Photos</span>
            </div>
            {/* Google Photos */}
            <div
              aria-hidden="true"
              className={`${styles.uploadOptionBox} ${styles.optionSlideIn} ${styles.optionDelay3}`}
              onClick={withLimitCheck(() => openCloudModal('googledrive'))}
            >
              <div className={styles.uploadOptionIcon}>
                <svg width="40" height="40" viewBox="0 0 122.88 122.88" xmlns="http://www.w3.org/2000/svg">
                  <path d="M30.72,27.97c16.95,0,30.72,13.77,30.72,30.72v2.83H2.83c-1.52,0-2.75-1.23-2.83-2.83 C0,41.73,13.77,27.97,30.72,27.97L30.72,27.97z" fill="#F6B704" />
                  <path d="M94.91,30.72c0,16.95-13.77,30.72-30.72,30.72l-2.75,0V2.83C61.44,1.3,62.67,0,64.19,0 C81.22,0,94.91,13.77,94.91,30.72L94.91,30.72z" fill="#E54335" />
                  <path d="M92.16,94.99c-16.95,0-30.72-13.77-30.72-30.72v-2.83h58.61c1.52,0,2.83,1.23,2.83,2.75 C122.88,81.22,109.11,94.99,92.16,94.99L92.16,94.99L92.16,94.99z" fill="#4280EF" />
                  <path d="M27.97,92.16c0-16.95,13.77-30.72,30.72-30.72h2.75v58.61c0,1.52-1.23,2.75-2.83,2.83 C41.66,122.88,27.97,109.11,27.97,92.16L27.97,92.16L27.97,92.16z" fill="#34A353" />
                </svg>
              </div>
              <span className={styles.uploadOptionText}>Google Photos</span>
            </div>
          </div>

          {/* ── Row 3 ── */}
          <div className={`${styles.uploadOptionsRow} ${styles.uploadOptionsRowCompact}`}>
            {/* Dropbox */}
            <div
              aria-hidden="true"
              className={`${styles.uploadOptionBox} ${styles.optionSlideIn} ${styles.optionDelay4}`}
              onClick={withLimitCheck(() => openCloudModal('dropbox'))}
            >
              <div className={styles.uploadOptionIcon}>
                <svg width="40" height="40" viewBox="0 0 43 40" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.5 0L0 8.1l8.6 6.9 12.5-7.8L12.5 0zM0 21.9l12.5 8.1 8.6-7.1-12.5-7.8L0 21.9zM21.1 22.9l8.6 7.1 12.5-8.1-8.6-6.8-12.5 7.8zM42.2 8.1L29.7 0l-8.6 7.2 12.5 7.8 8.6-6.9zM21.2 24.6l-8.6 7.1-4 -2.6v2.9l12.6 7.6 12.6-7.6v-2.9l-4 2.6-8.6-7.1z" fill="#0061ff" />
                </svg>
              </div>
              <span className={styles.uploadOptionText}>Dropbox</span>
            </div>
            {/* Google Drive */}
            <div
              aria-hidden="true"
              className={`${styles.uploadOptionBox} ${styles.optionSlideIn} ${styles.optionDelay4}`}
              onClick={withLimitCheck(() => openCloudModal('googledrive'))}
            >
              <div className={styles.uploadOptionIcon}>
                <svg width="32" height="32" viewBox="0 0 87.3 78" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.6 66.85l3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8H0c0 1.55.4 3.1 1.2 4.5l5.4 9.35z" fill="#0066DA" />
                  <path d="M43.65 25L29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3L1.2 52.35c-.8 1.4-1.2 2.95-1.2 4.5h27.5L43.65 25z" fill="#00AC47" />
                  <path d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57c.8-1.4 1.2-2.95 1.2-4.5H59.85L73.55 76.8z" fill="#EA4335" />
                  <path d="M43.65 25L57.4 1.2c-1.35-.8-2.9-1.2-4.5-1.2H34.35c-1.6 0-3.15.45-4.5 1.2L43.65 25z" fill="#00832D" />
                  <path d="M59.85 53H27.5l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.55c1.6 0 3.15-.45 4.5-1.2L59.85 53z" fill="#2684FC" />
                  <path d="M73.4 26.5l-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25l16.2 28h27.5c0-1.55-.4-3.1-1.2-4.5l-12.75-22z" fill="#FFBA00" />
                </svg>
              </div>
              <span className={styles.uploadOptionText}>Google Drive</span>
            </div>
          </div>
        </div>
      </div>

      <MobileUploadQRModal
        open={showMobileQr}
        onClose={() => setShowMobileQr(false)}
      />

      <CloudUploadModal
        open={cloudModalOpen}
        onClose={handleCloudModalClose}
        service={selectedCloudService}
        onFilesSelected={handleCloudFilesSelected}
        onShowMessage={(message) => setAppSnackbar({
          isVisible: true,
          message,
          type: 'default',
        })}
      />
    </StoragePage>
  );
};
